<template>

    <div class="layout__padding-clear layout__width-70 text__align-center">
        <div class="layout__margin-60-0 layout__overflow-hidden">

            <img class="layout__padding-20-0 layout__width-200px"
                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/connells/the-point.png">

            <p class="text__colour-white layout__padding-20-0">Land & New Homes</p>

            <div class="text__size-36 text__colour-white">Connells | The Point</div>

            <hr>

            <p class="text__line-height-30px text__colour-white">
                The Point is a new homes development in Bristol on the site of an old Royal Mail sorting house on a
                minor roundabout at the end of a busy high street. The X logo was a visual representation of X marks the
                spot, as the site was competing with significant noise locally. We needed to make a big impact to be
                seen.
            </p>

            <hr>

            <el-button class="button-red layout__width-200px"
                       v-on:click="showcase()">Back to our work
            </el-button>


            <div class="layout__overflow-hidden layout__margin-40-0">
                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/connells/the-point-case-study-.jpg">

                <div class="layout__padding-20-0 text__size-30 text__colour-white">
                    “Ravensworth produce high quality CGI every time and pay great attention to the features that turn a
                    house into a home. They’re an invaluable marketing partner that add real value”

                </div>

                <p class="text__colour-white layout__padding-20-0">Paul Matthews – Connells</p>

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/connells/the-point-case-study-2.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/connells/the-point-case-study-3.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/connells/the-pointCGI.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/connells/the-point-case-study-4.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/connells/the-point-case-study-5-1.jpg">

            </div>


        </div>
    </div>

</template>

<script>
    import Router from '../../../router';
    import {Carousel, Slide} from 'vue-carousel';

    export default {
        name: "landnewhomes",
        props: {},
        components: {
            Carousel,
            Slide
        },
        mixins: [],
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            },
            print() {
                Router.push({
                    name: '/products/print'
                });
            },
            digital() {
                Router.push({
                    name: '/products/print'
                });
            },
            showcase(page) {
                Router.push({
                    name: '/services/design-studio/our-work',
                    query: {
                        client: page,
                    }
                });
            }
        },
    };
</script>